import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  categories: [],
  category: null,
  pagination: {},
  favouritesToggled: true,
};

export const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setCategories: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.categories = payload;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    setPagination: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.pagination = payload;
    },
  },
});

export const { setLoading, setCategories, setError, setPagination } = categoriesSlice.actions;

export default categoriesSlice.reducer;

export const categorieselector = (state) => state.categories;
